'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _span;
var _excluded = ["className", "variant", "children", "removeDot"];
import * as React from 'react';
import { cn, getFromNestedObject } from "../utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var variants = {
  text: 'tw-bg-primary-light-100 tw-text-primary-light-400 dark:tw-bg-primary-dark-500 dark:tw-text-neutral-light-100',
  state: {
    active: 'tw-bg-success-100 tw-text-success-500',
    pending: 'tw-bg-neutral-light-300 tw-text-neutral-light-700',
    hold: 'tw-bg-on-hold-100 tw-text-on-hold-500',
    info: 'tw-bg-info-100 tw-text-info-500',
    deleted: 'tw-bg-alert-100 tw-text-alert-500'
  },
  user: {
    advanced: 'tw-text-neutral-light-100 tw-bg-info-400',
    intermediate: 'tw-text-neutral-light-800 tw-bg-success-400',
    beginner: 'tw-text-neutral-light-800 tw-bg-warning-400'
  }
};
function Tag(_ref) {
  var className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'text' : _ref$variant,
    children = _ref.children,
    _ref$removeDot = _ref.removeDot,
    removeDot = _ref$removeDot === void 0 ? false : _ref$removeDot,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    className: cn('focus:tw-ring-neutral-950 dark:focus:tw-ring-neutral-300 tw-font-caption tw-inline-flex tw-h-2.4 tw-items-center tw-rounded-full tw-px-1.2 tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2', getFromNestedObject(variants, variant.split('.')), className)
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("span", {
      className: "tw-flex tw-items-center tw-justify-center tw-gap-0.8",
      children: [variant.includes('state') && !removeDot ? _span || (_span = /*#__PURE__*/_jsx("span", {
        className: "tw-flex tw-h-0.4 tw-w-0.4 tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full",
        children: "\u25CF"
      })) : null, /*#__PURE__*/_jsx("span", {
        className: "tw-line-clamp-1",
        children: children
      })]
    })
  }));
}
export { Tag };